/* eslint-disable */

import React from 'react';
import './input.less';
import { Form } from 'antd';
import { customValidators } from 'utils';
import { Input } from 'components';

const InputGSM = (props) => {
    return (
      <Form.Item
      name="msisdn"
      rules={[
        {
          len: 10,
          validator: customValidators.isMsisdn,
          required:true,
          type: "number",
        },
      ]}
      getValueFromEvent={(e) => {
        const convertedValue = Number(e.target.value);
        if (isNaN(convertedValue)) {
          return "";
        } else {
          return convertedValue;
        }
      }}
    >
      <Input maxLength="10" 
        autoComplete="off"  
        {...props}
        style={{ width: '100%' }}
      />
    </Form.Item>
    );
}


export default InputGSM